export default "/device-repository/assets/hamburger-menu-close.5afa3d0b9609aa6308c07ad09f30ecd2.svg";